import { RestSlice } from '../../../../redux/rest.slice';
import { Extractor, RegulatoryProgramName } from '@rcp/types';
import { Resource, localizationService } from 'src/services';

export const fogDevicesSlice = new RestSlice<Extractor>(
	RegulatoryProgramName.FOG + localizationService.getLocalizedString('extractor.devices'),
	Resource.Extractors
);
export const fogDevicesReducer = fogDevicesSlice.rests.reducer;
